// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_04e985","link":"_ec2383"};